/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:54:41
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title20 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import DBTable from '../components/DBTable';
import Form from './Form';
import Form1 from './Form1';
import Form2 from './Form2';
import FormChart from './FormChart';
import FormChart1 from './FormChart1';
import FormChart2 from './FormChart2';
import { drop, forEach } from 'lodash';


class P20 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      tableColumns: [],
      tableList: [],
      chartColorList: [],
      tableColumns1: [],
      tableList1: [],
      chartColorList1: [],
      tableColumns2: [],
      tableList2: [],
      chartColorList2: [],
    }
  }

  fillColor = (tableColumns, list) => {
    console.log('list',list)

    const border = `1px solid #000`;
    let max = 0, min = 0;
    let valMax = 0, valMin = 0;
    list && list.forEach((ele) => {
      let ii = 0;
      forEach(ele, (val, key) => {
        console.log('val',val)

        if (key !== 'key_0') {
          if (ii === 0) {
            valMin = parseFloat(val);
            valMax = parseFloat(val);
          } else {
            valMin = Math.min(parseFloat(val), valMin)
            valMax = Math.max(parseFloat(val), valMax)
          }
          console.log('valMin',valMin)
          ii += 1;
        }
      })
    })

    drop(tableColumns, 1).forEach((ele, i) => {
      if (i === 0) {
        min = parseFloat(ele.title);
        max = parseFloat(ele.title);
      } else {
        min = Math.min(parseFloat(ele.title), min)
        max = Math.max(parseFloat(ele.title), max)
      }
    });

    const getColor = (isMin, isMax) => isMin ? '#34a471' : isMax ? '#c00000' : '#000'
    return tableColumns.map(item => {
      return {
        ...item,
        style: (_, i) => {
          const isMin = `${min}%` === _.title;
          const isMax = `${max}%` === _.title;
          return {
            ...item.style,
            height: 60,
            fontSize: 18,
            fontWeight: 'bold',
            textAlign: 'center',
            background: '#fff',
            color: getColor(isMin, isMax),
            borderLeft: i === 0 ? border : 'none',
            borderTop: border,
            borderRight: border,
            borderBottom: border,
          }
        },
        colStyle: (_, __, i) => {

          return {
            height: 60,
            fontSize: 18,
            fontWeight: 'bold',
            textAlign: 'center',
            borderLeft: i === 0 ? border : 'none',
            borderRight: border,
            borderBottom: border,
            background: '#fff',
          }
        },
        render: (val) => {
          const isMin = `${valMin}%` === val;
          const isMax = `${valMax}%` === val;

          return <span style={{ color: getColor(isMax, isMin) }}>{val}</span>;
        }
      }
    })
  }

  render() {
    const {
      chartTitle,
      chartList,
      chartColorList,
      chartTitle1,
      chartList1,
      chartColorList1,
      chartTitle2,
      chartList2,
      chartColorList2,
      tableColumns,
      tableList,
      tableColumns1,
      tableList1,
      tableColumns2,
      tableList2
    } = this.state;
    return (
      <Stage>
        <Title20 pageNumber="1.2">用户体验“3E”感知维度整体数据对比 <span className={s.titleHint}>| 品牌整体</span></Title20>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>凉介三大感知指标较为均衡</div>
            <div contentEditable className={s.desWrapper}>
              <div className={s.des}>
                <span style={{ color: '#c00000', fontWeight: 'bold' }}>
                  三大感知维度凉介表现：效用第三、简便第二、情感第三；
                </span>
              </div>
              <div className={s.des}>
                西屋三大维度均表现最优，飞利浦效用、简便最弱，SKG情感最弱。
              </div>
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart
                  options={setChart({
                    label: chartTitle,
                    list: chartList, color: chartColorList,
                    title: '品牌整体-效用'
                  })}
                />
              </TooltipDrawer>
              <TooltipDrawer formContent={<FormChart1 onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({ label: chartTitle1, list: chartList1, color: chartColorList1, title: '品牌整体-简便' })} />
              </TooltipDrawer>
              <TooltipDrawer formContent={<FormChart2 onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({ label: chartTitle2, list: chartList2, color: chartColorList2, title: '品牌整体-情感' })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns, tableList)} data={tableList} />
              </TooltipDrawer>

              <TooltipDrawer formContent={<Form1 onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns1, tableList1)} data={tableList1} />
              </TooltipDrawer>

              <TooltipDrawer formContent={<Form2 onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns2, tableList2)} data={tableList2} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P20);



// WEBPACK FOOTER //
// src/routes/visualChart/P20/index.js